import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { apparatusList, benefitBadges } from '../../data/keyBenefits';
export function KeyBenefits() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-109" data-mp="1vuizo82zi8eh">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-110" data-mp="1vsy7uq8213kb">
        <SectionTag icon="📚" tone="accent" data-id="element-111" data-mp="1qx0umss38dbr">
          +280 páginas de contenido
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-112" data-mp="2oiexjg4ai6cu">
          +240 ejercicios detallados
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-113" data-mp="2eljxutwa5zwz">
          Mat, Reformer, Cadillac, Silla, Accesorios, Pared y Terapéutico — listo para usar mañana.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-114" data-mp="29otjcb04jcdo">
          {apparatusList.map(item => <span key={item} className="rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-sm font-medium text-primary" data-id="element-115" data-mp="y7k5c3zrlcjr">
              {item}
            </span>)}
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-4 px-4 sm:grid-cols-3 sm:px-6" data-id="element-116" data-mp="1vcb47jmjw0q">
        {benefitBadges.map((badge, i) => <m.div key={badge.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className="flex flex-col items-start gap-3 rounded-2xl border border-primary/10 bg-paper p-5 shadow-card-light" data-id="element-117" data-mp="3o3bw3b7qxq1e" data-mpi={i}>
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10" data-id="element-118" data-mp="30fkj05edt8z2">
              <badge.icon size={20} className="text-primary" data-id="element-119" data-mp="35d3wv4763jqh" />
            </div>
            <div data-id="element-120" data-mp="2recpe0mt8wbb">
              <p className="font-heading text-sm font-semibold text-primary" data-id="element-121" data-mp="2rduqew8rk3zp">{badge.title}</p>
              <p className="mt-1 text-sm leading-relaxed text-ink/80" data-id="element-122" data-mp="2vdv6elbign8v">{badge.text}</p>
            </div>
          </m.div>)}
      </div>
    </section>;
}